module.exports = __webpack_public_path__ + "media/newstyle/images/icon-epub-870a5943f46da6ac1c0cc0341cf185f4.svg";